import * as React from 'react';
import { UserContext } from '@app/Context/UserContext';
import { SimpleList, SimpleListItem, SimpleListGroup } from '@patternfly/react-core';
import EStatementDetails from '@app/Components/Report/eStatements/Details';
import ReportDataHelper from '@app/Service/Report/ReportDataHelper';
import moment from 'moment-timezone';

interface EStatementsListReportProps {
    pageId: number,
    setLastUpdatedText: React.Dispatch<React.SetStateAction<string>>;
    reportType: string;
}

const EStatementsListReport: React.FC<EStatementsListReportProps> = ({ pageId, setLastUpdatedText, reportType }) => {
    const { userState } = React.useContext(UserContext);

    const [selectedDate, setSelectedDate] = React.useState<moment.Moment | null>(null);

    // This report lists the last 10 Wednesdays, and allows the user to pull a snapshot of data for the week
    // leading up to that day
    const getStatementDates = () => {
        // Start with the current week's Wednesday
        let startDate = moment().startOf('isoWeek').add(2, 'days');
        // If it's currently before Wed, our start date is last Wed
        if (moment().weekday() < 3) {
            startDate = startDate.subtract(1, 'weeks');
        }

        const days = [startDate];

        for (let index = 0; index < 9; index++) {
            const lastDayClone = moment(days[days.length - 1]);
            days.push(lastDayClone.subtract(1, 'weeks'));
        }

        return days;
    };

    // Set last updated text
    React.useEffect(() => {
        const controller = new AbortController();

        let mounted = true;

        ReportDataHelper
            .getTableUpdatedText(controller, 'ndaWeb_QualityComponents')
            .then(text => { if (mounted) setLastUpdatedText(text) });

        return () => {
            mounted = false;
            controller?.abort();
        };

    }, []);

    // Show statement details component if date selected
    if (selectedDate) {
        return <EStatementDetails
            selectedDate={selectedDate}
            clearSelectedDate={() => setSelectedDate(null)}
            pageId={pageId}
            reportType={reportType}
        />;
    }

    // Show list of statements dates if no date selected
    return (
        <>
            <SimpleList>
                <SimpleListGroup title="Statement Date">
                    {
                        getStatementDates().map(date =>
                            <SimpleListItem
                                key={date.format('X')}
                                onClick={e => setSelectedDate(date)}
                            >
                                {date.format('dddd, MMMM DD, YYYY')}
                            </SimpleListItem>
                        )
                    }
                </SimpleListGroup>
            </SimpleList>
        </>
    );
};

export default EStatementsListReport;